@if (compact()) {
  @if (total()) {
    <ng-template #breakdown>
      <div class="flex flex-col gap-2 p-4">
        <strong>Incident breakdown</strong>
        @for (item of breakdownItems(); track item.severity) {
          <div class="flex items-center gap-2 text-sm font-medium">
            <avs-incident-severity-icon [severity]="item.severity" />
            <span class="capitalize">{{ item.severity }}</span>
            <span>{{ item.count }}</span>
          </div>
        }
      </div>
    </ng-template>
    <span
      [class]="compactClass()"
      [tp]="breakdown"
      [tpHideOnEscape]="true"
      role="button"
      tabindex="0"
      tpPlacement="right"
      tpTrigger="mouseenter focus"
      tpVariation="popper"
    >
      @if (isIcon()) {
        <avs-incident-severity-icon [severity]="highestSeverity()" />
      }
      <span aria-hidden="true">{{ total() }}</span>
      <span class="sr-only">{{ compactLabel() }}</span>
    </span>
  } @else if (showZero()) {
    <span class="severity-zero text-xs font-medium">0</span>
  }
} @else {
  @for (item of items(); track item.severity) {
    <span
      [class]="item.cssClass"
      [tp]="item.label"
      [tpIsEnabled]="canHover"
      [tpIsLazy]="true"
    >
      @if (isIcon()) {
        <avs-incident-severity-icon [severity]="item.severity" />
      }
      {{ item.count }}
      <span class="sr-only">{{ item.severity }}</span>
    </span>
  }
}
